import helper from '../../../helpers/steinerHelper';
    
export const actionTypes = helper.createActionTypes('portaliIndicatoriHotels');
export const actions = helper.createActions('portaliIndicatoriHotels', actionTypes);